import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        " * {\n    color: currentColor;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import { Bold, Box, Heading, Italic, Link, ListItem, OrderedList, Text, Underlined, UnorderedList } from "@miro-site/core";
import React from "react";
import styled from "styled-components";
var _obj, _obj1;
var options = {
    renderMark: (_obj = {}, _define_property(_obj, MARKS.BOLD, function(text) {
        return /*#__PURE__*/ _jsx(Bold, {
            children: text
        });
    }), _define_property(_obj, MARKS.ITALIC, function(text) {
        return /*#__PURE__*/ _jsx(Italic, {
            children: text
        });
    }), _define_property(_obj, MARKS.UNDERLINE, function(text) {
        return /*#__PURE__*/ _jsx(Underlined, {
            children: text
        });
    }), _obj),
    renderNode: (_obj1 = {}, _define_property(_obj1, BLOCKS.HEADING_1, function(node, children) {
        return /*#__PURE__*/ _jsx(Heading, {
            as: "h1",
            $variant: "h3",
            $mb: 40,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_2, function(node, children) {
        return /*#__PURE__*/ _jsx(Heading, {
            as: "h2",
            $variant: "h3",
            $mb: 40,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_3, function(node, children) {
        return /*#__PURE__*/ _jsx(Heading, {
            as: "h3",
            $variant: "h4",
            $mb: 24,
            $mt: 40,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_4, function(node, children) {
        return /*#__PURE__*/ _jsx(Heading, {
            as: "h4",
            $variant: "h4",
            $mb: 24,
            $mt: 40,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_5, function(node, children) {
        return /*#__PURE__*/ _jsx(Heading, {
            as: "h5",
            $variant: "h4",
            $mb: 24,
            $mt: 40,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.HEADING_6, function(node, children) {
        return /*#__PURE__*/ _jsx(Heading, {
            as: "h6",
            $variant: "h4",
            $mb: 24,
            $mt: 40,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.PARAGRAPH, function(node, children) {
        return /*#__PURE__*/ _jsx(Text, {
            $variant: "p1",
            $mb: 24,
            children: children
        });
    }), _define_property(_obj1, BLOCKS.OL_LIST, function(node, children) {
        return /*#__PURE__*/ _jsx(OrderedList, {
            $variant: "default",
            children: React.Children.map(children, function(child) {
                return /*#__PURE__*/ _jsx(ListItem, {
                    $variant: "p1",
                    children: child
                });
            })
        });
    }), _define_property(_obj1, BLOCKS.UL_LIST, function(node, children) {
        return /*#__PURE__*/ _jsx(UnorderedList, {
            $variant: "default",
            children: React.Children.map(children, function(child) {
                return /*#__PURE__*/ _jsx(ListItem, {
                    $variant: "p1",
                    children: child
                });
            })
        });
    }), _define_property(_obj1, BLOCKS.LIST_ITEM, function(node, children) {
        return children;
    }), _define_property(_obj1, INLINES.HYPERLINK, function(node, children) {
        return /*#__PURE__*/ _jsx(Link, {
            href: node.data.uri,
            $variant: "richText",
            $size: "default",
            $color: "default",
            children: children
        });
    }), _obj1)
};
var RichTextBase = function(_param) {
    var document = _param.document, props = _object_without_properties(_param, [
        "document"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, props), {
        children: documentToReactComponents(document, options)
    }));
};
var RichText = styled(RichTextBase).withConfig({
    componentId: "sc-b1b3a78e-0"
})(_templateObject(), Link);
export default RichText;
